import {IAppsModel} from '../../types/apps/AppsModel'

export const totalUsersCount = (app: IAppsModel) => {
  if (app.crm === 'BITRIX24' && app.settings?.bitrix24) {
    if (app.settings.bitrix24.users_in_service === true) {
      return app.settings.bitrix24.users_in_service_list.length
    } else {
      return app.settings.bitrix24.users_list.length
    }
  } else if (app.crm === 'AMOCRM' && app.settings?.amocrm) {
    return app.settings.amocrm.users.length
  } else {
    return 0
  }
}

export const activeUsersCount = (app: IAppsModel) => {
  let users_number = 0
  if (app.crm === 'BITRIX24' && app.settings?.bitrix24) {
    if (app.settings.bitrix24.users_in_service === true) {
      for (let i = 0; i < app.settings.bitrix24.users_in_service_list.length; i++) {
        if (app.settings.bitrix24.users_in_service_list[i].is_active) users_number += 1
      }
    } else {
      for (let i = 0; i < app.settings.bitrix24.users_list.length; i++) {
        if (app.settings.bitrix24.users_list[i].internal_number !== '') users_number += 1
      }
    }
  } else if (app.crm === 'AMOCRM' && app.settings?.amocrm) {
    users_number = app.settings.amocrm.users.filter((u) => u.is_active).length
  }

  return users_number
}
